<template>
  <a-modal title="专家密码"
           :width="1000"
           :visible="visible"
           :footer="null"
           :maskClosable="false"
           @cancel="$emit('cancel')">
    <div>
      <a-card>
        <div style="font-size:100px;color: green;text-align: center ">{{mm}}</div>
        <div style="text-align: center "><a-button class="ml-1 mr-1" type="primary" :loading="loading" icon="" @click="reMm">重新生成</a-button></div>
      </a-card>
    </div>
  </a-modal>
</template>

<script>
  import qs from 'qs'
  export default {
    name: 'PbxzszMm',
    props: ['visible'],
    components: {
    },
    data () {
      return {
        mm:'',
        xmid:'',
        loading:false
      }
    },
    mounted () {
    },
    created () {

    },
    methods: {
      reMm(){
        this.createMm(this.xmid,"1")
      },
      checkMm(xmid){
        let that = this
        that.xmid=xmid
        that.$http.get('/api/1/bidApply/pbxzsz/queryZjByXmid.json?xmid=' + xmid).then(function (res) {
          if (200===res.code)
          {
            if (res.result)
            {
              that.mm=res.result
            }else {
              that.createMm(xmid)
            }
          }
        })
      },
      createMm(xmid,val){
        let that = this
        if ("1"===val)
        {
          that.loading=true
        }
        that.$http.get('/api/1/bidApply/pbxzsz/createZjMm.json?xmid=' + xmid).then(function (res) {
          that.loading=false
          if (200===res.code)
          {
            that.mm=res.result
            that.$message.success("生成成功")
          }
        })
      },
    }
  }
</script>

<style scoped>
</style>
